// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/metabase.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/metabase.proto.
 */
export const file_api_proto_v1_metabase: GenFile = /*@__PURE__*/
  fileDesc("ChthcGlfcHJvdG8vdjEvbWV0YWJhc2UucHJvdG8SDGFwaV9wcm90by52MSIrCghNZXRhYmFzZRISCgpjb21wYW55X2lkGAEgASgDEgsKA3VybBgCIAEoCSJRChNHZXRNZXRhYmFzZVJlc3BvbnNlEi0KCG1ldGFiYXNlGAEgASgLMhYuYXBpX3Byb3RvLnYxLk1ldGFiYXNlSACIAQFCCwoJX21ldGFiYXNlIhQKEkdldE1ldGFiYXNlUmVxdWVzdEIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM");

/**
 * @generated from message api_proto.v1.Metabase
 */
export type Metabase = Message<"api_proto.v1.Metabase"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message api_proto.v1.Metabase.
 * Use `create(MetabaseSchema)` to create a new message.
 */
export const MetabaseSchema: GenMessage<Metabase> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_metabase, 0);

/**
 * @generated from message api_proto.v1.GetMetabaseResponse
 */
export type GetMetabaseResponse = Message<"api_proto.v1.GetMetabaseResponse"> & {
  /**
   * @generated from field: optional api_proto.v1.Metabase metabase = 1;
   */
  metabase?: Metabase;
};

/**
 * Describes the message api_proto.v1.GetMetabaseResponse.
 * Use `create(GetMetabaseResponseSchema)` to create a new message.
 */
export const GetMetabaseResponseSchema: GenMessage<GetMetabaseResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_metabase, 1);

/**
 * @generated from message api_proto.v1.GetMetabaseRequest
 */
export type GetMetabaseRequest = Message<"api_proto.v1.GetMetabaseRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetMetabaseRequest.
 * Use `create(GetMetabaseRequestSchema)` to create a new message.
 */
export const GetMetabaseRequestSchema: GenMessage<GetMetabaseRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_metabase, 2);

